module.exports = __webpack_public_path__ + "img/arrow-down-to-square.d7fadc44.svg";